import React from 'react';
import '../../styles/Faq/heroFaq.css'; 

const HeroSection = () => {
  return (
    <section className="hero-sectionFaq">
      {/* 1. The Dark Overlay */}
      <div className="hero-overlay"></div>

      {/* 2. The Content */}
      <div className="container hero-content">
        <div className="row justify-content-center justify-content-md-start">
          <div className="col-12 col-md-10 col-lg-8">
            
            {/* Breadcrumb */}
            <div className="mb-2">
              <span className="text-white-50 fw-bold">Home</span>
              <span className="mx-2 text-white-50">|</span>
              <span className="text-white fw-bold">FAQ</span>
            </div>

            {/* Headline */}
            <h1 className="display-4 text-white fw-bold">
              FAQ
            </h1>
            
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;